<template>
  <Icon
    v-if="icon"
    :icon="`circle-flags:${icon?.toLowerCase()}`"
    class="size-4 border rounded-full border-gray"
  />
</template>
<script setup lang="ts">
import { Icon } from "@iconify/vue";

defineProps<{
  icon?: string | null;
}>();
</script>

<style scoped>
.border-gray {
  color: #d9d9d9;
}
</style>
